
import { DetectedLocation } from '../mappings/LocationMapping';

export const applyLocationFilter = (dbQuery: any, detectedLocation: DetectedLocation) => {
  const { type, info } = detectedLocation;
  
  console.log('=== APPLYING HIERARCHICAL LOCATION FILTER ===');
  console.log('Filter type:', type);
  console.log('Filter info:', JSON.stringify(info, null, 2));
  
  if (type === 'city') {
    console.log('*** APPLYING CITY FILTER (HIGHEST PRIORITY) ***');
    console.log('City:', info.city, 'Region:', info.region, 'Country:', info.country);
    
    // For city search, be very specific - must match exact city
    const result = dbQuery
      .eq('country', info.country)
      .eq('region', info.region)
      .ilike('city', `%${info.city}%`);
    
    console.log('🎯 Applied STRICT city filter:', {
      country: info.country,
      region: info.region, 
      city: info.city
    });
    return result;
    
  } else if (type === 'region') {
    console.log('*** APPLYING REGION FILTER (MEDIUM PRIORITY) ***');
    console.log('Region:', info.region, 'Country:', info.country);
    
    // For region search, show all cities in that region
    const result = dbQuery
      .eq('country', info.country)
      .eq('region', info.region);
    
    console.log('🎯 Applied region filter:', {
      country: info.country,
      region: info.region
    });
    return result;
    
  } else if (type === 'country') {
    console.log('*** APPLYING COUNTRY FILTER (LOWEST PRIORITY) ***');
    console.log('Target country:', info.country);
    
    // For country search, show all results from that country
    const result = dbQuery.eq('country', info.country);
    
    console.log('🎯 Applied country filter:', {
      country: info.country
    });
    return result;
  }
  
  console.log('❌ NO LOCATION FILTER APPLIED - this should not happen!');
  return dbQuery;
};

// Function to apply coastal exclusions ONLY for Netherlands
export const applyCoastalExclusionsForCountry = (dbQuery: any, searchTerms: string[], country: string) => {
  const hasCoastalTerms = searchTerms.some(term => {
    const lowerTerm = term.toLowerCase();
    return lowerTerm.includes('kust') || lowerTerm.includes('strand') || lowerTerm.includes('zee');
  });

  // Only apply for Netherlands and only with coastal terms
  if (hasCoastalTerms && country === 'Nederland') {
    console.log('Applying coastal exclusions for Netherlands coastal search');
    
    return dbQuery
      .not('region', 'ilike', '%limburg%')
      .not('region', 'ilike', '%brabant%')
      .not('region', 'ilike', '%gelderland%')
      .not('region', 'ilike', '%utrecht%')
      .not('region', 'ilike', '%overijssel%')
      .not('region', 'ilike', '%drenthe%')
      .not('region', 'ilike', '%flevoland%')
      .not('city', 'ilike', '%maastricht%')
      .not('city', 'ilike', '%eindhoven%')
      .not('city', 'ilike', '%utrecht%')
      .not('city', 'ilike', '%arnhem%')
      .not('city', 'ilike', '%nijmegen%')
      .not('city', 'ilike', '%apeldoorn%')
      .not('city', 'ilike', '%enschede%')
      .not('city', 'ilike', '%zwolle%')
      .not('city', 'ilike', '%deventer%')
      .not('city', 'ilike', '%amersfoort%')
      .not('description', 'ilike', '%meer%')
      .not('description', 'ilike', '%lake%')
      .not('name', 'ilike', '%meer%')
      .not('name', 'ilike', '%lake%');
  }
  
  return dbQuery;
};
